export default __webpack_public_path__ + "static/media/app_medication.53414aa5.jpg";